module.exports = __webpack_public_path__ + "static/media/beehive-08.3b045b36.png";